import router from '@/router';
import store from '@/store';

const routes = [
  {
    name: 'Login',
    component: () => import(/* webpackChunkName: "Login" */ '@/variants/whb/pages/login/Login.vue'),
    meta: {
      background: 'variants/marcussecurity/assets/login-bg.jpg',
      logo: 'variants/whb/assets/logo-dark.svg',
      subtitle: 'West Hungária Bau beléptetőrendszer',
      title: 'Bejelentkezés'
    },
  },
];

router.$addRoutes(routes);

export default router;
